import clsx from "clsx";
import React from "react";
import { createPluggable } from "pluggable-react";
import styles from "./Kbd.module.scss";

export const isMac = () => {
  if (typeof navigator === "undefined") return false;
  if ("userAgentData" in navigator) {
    const platform = (navigator.userAgentData as any).platform;
    return platform.toLowerCase().indexOf("mac") !== -1 || platform === "iPhone";
  }
  if ("platform" in navigator) {
    // @ts-ignore
    return navigator.platform.toLowerCase().indexOf("mac") !== -1 || navigator.platform === "iPhone";
  }
  return false;
};

export const isMod = (e: React.MouseEvent) => {
  return isMac() ? e.metaKey : e.ctrlKey;
};

export const modKey = isMac() ? "⌘" : "ctrl";
export const altKey = isMac() ? "⌥" : "alt";
export const shiftKey = "⇧";

export type KbdProps = {
  className?: string;
  keys: string | string[];
  variant?: "contained" | "text" | "separate";
  color?: "light" | "dark";
  delimiter?: string;
  gap?: string;
  inline?: boolean;
};

const DefaultKbd = ({ keys, variant = "contained", color = "light", delimiter, gap = "0.25rem", inline = false, className, ...props }: KbdProps) => {
  const keyList = Array.isArray(keys) ? keys : [keys];
  let mappedKeys = keyList.map((k) => k.replace("mod", modKey).replace("alt", altKey).replace("shift", shiftKey));

  if (delimiter) {
    mappedKeys = mappedKeys.reduce((acc, k) => [...acc, k, delimiter], [] as string[]).slice(0, -1);
  }

  return (
    <kbd
      {...props}
      className={clsx(styles.kbd, className)}
      style={{ gap, display: inline ? "inline-flex" : "flex" }}
      data-variant={variant}
      data-color={color}
    >
      {mappedKeys.map((k) => (
        <span key={k}>{k}</span>
      ))}
    </kbd>
  );
};

export const Kbd = createPluggable<KbdProps>("deci.kbd", DefaultKbd);

export default Kbd;
